import React from 'react';
import { Check, ShoppingCart, MessageCircle } from 'lucide-react';
import { useCart } from '../context/CartContext';
import { resolveImageUrl } from '../utils/imageUrl';

const ProductCard = ({ product }) => {
  const { addToCart } = useCart();
  const whatsappNumber = '+917795529749';

  const handleShopNow = async () => {
    await addToCart(product.id, 1);
  };

  const handleWhatsApp = () => {
    const message = encodeURIComponent(
      `Hi! I'm interested in ${product.name} (₹${product.price}). Can you provide more information?`
    );
    window.open(`https://wa.me/${whatsappNumber.replace(/[^0-9]/g, '')}?text=${message}`, '_blank');
  };

  return (
    <div 
      className="product-card bg-white rounded-lg shadow-lg overflow-hidden flex flex-col"
      data-testid={`product-card-${product.id}`}
    >
      {/* Product Image */}
      <div className="h-48 overflow-hidden bg-cream">
        <img 
          src={resolveImageUrl(product.image_url)} 
          alt={product.name}
          className="w-full h-full object-cover"
          data-testid={`product-image-${product.id}`}
        />
      </div>

      {/* Product Content */}
      <div className="p-6 flex-grow flex flex-col">
        <div className="mb-2">
          <span 
            className="text-xs font-semibold text-golden uppercase tracking-wide"
            data-testid={`product-category-${product.id}`}
          >
            {product.category === 'hair' ? 'Hair Care' : 'Skin Care'}
          </span>
        </div>
        
        <h3 
          className="text-xl font-bold text-dark-text mb-2"
          data-testid={`product-name-${product.id}`}
        >
          {product.name}
        </h3>

        {/* Price */}
        <div className="mb-3">
          <span className="text-2xl font-bold text-golden" data-testid={`product-price-${product.id}`}>
            ₹{product.price}
          </span>
        </div>
        
        <p 
          className="text-gray-700 text-sm mb-4 leading-relaxed"
          data-testid={`product-description-${product.id}`}
        >
          {product.description}
        </p>

        {/* Key Benefits */}
        <div className="mb-4 flex-grow">
          <h4 className="text-sm font-semibold text-dark-text mb-2">Key Benefits:</h4>
          <ul className="space-y-2">
            {product.key_benefits.slice(0, 3).map((benefit, index) => (
              <li 
                key={index} 
                className="flex items-start text-sm text-gray-700"
                data-testid={`product-benefit-${product.id}-${index}`}
              >
                <Check size={16} className="text-golden mr-2 mt-0.5 flex-shrink-0" />
                <span>{benefit}</span>
              </li>
            ))}
          </ul>
        </div>

        {/* Action Buttons */}
        <div className="space-y-2 mt-auto">
          <button
            onClick={handleShopNow}
            data-testid={`shop-now-${product.id}`}
            className="w-full btn-primary px-4 py-3 rounded-lg font-semibold text-sm flex items-center justify-center gap-2"
          >
            <ShoppingCart size={18} />
            Shop Now
          </button>
          
          <button
            onClick={handleWhatsApp}
            data-testid={`whatsapp-${product.id}`}
            className="w-full bg-green-500 hover:bg-green-600 text-white px-4 py-3 rounded-lg font-semibold text-sm flex items-center justify-center gap-2 transition-colors"
          >
            <MessageCircle size={18} />
            WhatsApp Inquiry
          </button>
        </div>
      </div>
    </div>
  );
};

export default ProductCard;
